import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { AtsJobsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ActiveJobsLimitWarning } from 'modules/ats/components/ActiveJobsLimitWarning'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { FavouritesList } from './FavouriteList'
import JobsTable from './JobsTable'

const JobsPage = () => {
  const {
    access: { id: accessId },
  } = useCurrentSession()

  const { data, loading: loadingPage } = useQuery(AtsJobsPageDocument, {
    variables: { authorId: accessId },
  })

  const [favouriteOperations, setFavouriteOperations] = useState<{
    adding: boolean
    deleting: number | null
  }>({
    adding: false,
    deleting: null,
  })

  const favouriteJobs = data?.ats.favouriteJobPostingsConnection.nodes || []

  const handleAddFavourite = (status: boolean) => {
    setFavouriteOperations((prev) => ({ ...prev, adding: status }))
  }

  const handleDeleteFavourite = (jobId: number | null) => {
    setFavouriteOperations((prev) => ({ ...prev, deleting: jobId }))
  }

  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <Box gap="s16">
        <ActiveJobsLimitWarning />
        <Box gap="s20">
          <FavouritesList
            favouriteJobs={favouriteJobs}
            isAddingFavourite={favouriteOperations.adding}
            deletingFavouriteJob={favouriteOperations.deleting}
            onDeleteFavourite={handleDeleteFavourite}
            loading={loadingPage}
          />

          <JobsTable
            favouriteJobs={favouriteJobs}
            onAddFavourite={handleAddFavourite}
            onDeleteFavourite={handleDeleteFavourite}
          />
        </Box>
      </Box>
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default JobsPage
